import {useEffect, useState} from "react";
import {PresentationItem} from "../types/presentation";
import {presentationService} from "../services/presentationItems-service";
import {useForm} from "antd/es/form/Form";
import {openSuccessNotification, showErrorNotification} from "../helpers/mainHelpers";
import {Modal} from "antd";
import {DeleteOutlined} from "@ant-design/icons";

export const usePresentationController = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [isPresentationModalOpen, setIsPresentationModalOpen] = useState(false)
  const [presentationItems, setPresentationItems] = useState<PresentationItem[]>([])
  const [selectedPresentationItem, setSelectedPresentationItem] = useState<PresentationItem | undefined>(undefined)
  const [lastUpdate, setLastUpdate] = useState(0)
  const [form] = useForm()

  useEffect(() => {
    if (!isPresentationModalOpen) {
      setSelectedPresentationItem(undefined)
      form.resetFields()
    }
  }, [isPresentationModalOpen])

  useEffect(() => {
    fetchPresentationItems([])
  }, [lastUpdate])

  const togglePresentationModal = () => {
    setIsPresentationModalOpen(!isPresentationModalOpen)
  }

  const toggleLastUpdate = () => {
    setLastUpdate(Date.now)
  }

  const deletePresentationItem = async (id: string) => {
    setIsLoading(true)
    try {
      await presentationService.delete(id)
      openSuccessNotification("Презентаційний запис успішно видалено!")
      toggleLastUpdate()
    } catch (error) {
      showErrorNotification({message: "Помилка видалення презентаційного запису!", description: JSON.stringify(error)});
    } finally {
      setIsLoading(false)
    }
  }

  const confirmDeletePresentationItem = (props: { presentationId: string }) => {
    const {presentationId} = props
    const {confirm} = Modal;

    confirm(
      {
        width: 400,
        icon: <DeleteOutlined/>,
        title: `Видалити запис ?`,
        okText: "Видалити",
        okButtonProps: {danger: true},
        cancelText: "Cкасувати",
        onOk: async () => {
          await deletePresentationItem(presentationId)
        },
      });

  }

  const createPresentationItem = async (data: PresentationItem) => {
    setIsLoading(true)
    try {
      await presentationService.createPresentationItem(data)
      togglePresentationModal()
      toggleLastUpdate()
      openSuccessNotification("Презентаційний запис успішно додано!")
    } catch (error) {
      showErrorNotification({message: "Помилка додавання презентаційного запису!", description: JSON.stringify(error)});

    } finally {
      setIsLoading(false)
    }
  }

  const updatePresentationItem = async (data: PresentationItem) => {
    setIsLoading(true)
    try {
      await presentationService.update({$id: selectedPresentationItem?.$id, ...data})
      togglePresentationModal()
      toggleLastUpdate()
      openSuccessNotification("Презентаційний запис успішно оновлено!")
    } catch (error) {
      showErrorNotification({message: "Помилка оновлення презентаційного запису!", description: JSON.stringify(error)});
    } finally {
      setIsLoading(false)
    }
  }

  const fetchPresentationItems = async (queries: string[]) => {
    setIsLoading(true)
    try {
      const response = await presentationService.list(queries)
      const presentationItems = response
      setPresentationItems(presentationItems)

    } catch (error) {
      console.error(error)
      showErrorNotification({message: "Помилка завантаження записів презентації!"});
    } finally {
      setIsLoading(false)
    }
  }

  const submitFormHandler = async (presentationData: PresentationItem) => {
    if (selectedPresentationItem) {
      await updatePresentationItem(presentationData)
    } else {
      await createPresentationItem(presentationData)
    }
  }

  const editButtonHandler = (presentationItem: PresentationItem) => {
    setSelectedPresentationItem(presentationItem)
    togglePresentationModal()
  }


  return {
    isLoading,
    isPresentationModalOpen,
    togglePresentationModal,
    presentationItems,
    fetchPresentationItems,
    form,
    submitFormHandler,
    confirmDeletePresentationItem,
    editButtonHandler,
    selectedPresentationItem
  }

}

